﻿import React, { useState, useEffect } from 'react';
import { CrudFunctions } from '../utilities/crud-functions';
import { Technology } from '../models/technology';
import { LookupItem } from '../models/lookup-item';
import { CompStandard } from '../models/comp-standard';
import { BenchSheet } from '../models/benchsheet';
import { BatchBenchSheetProductData } from '../models/batch-bench-sheet-product-data';
import { ModalMetadata } from '../models/modal-metadata';
import { BenchSheetTechnologyType, ModalMessageType } from '../models/enums';
import GlobalDialog from './Modal/GlobalDialog';
import { ToastProps } from '../models/toast-props';

import { Toast } from 'devextreme-react/toast';
import { SelectBox } from 'devextreme-react/select-box';
import { List } from 'devextreme-react/list';
import { TextArea } from 'devextreme-react/text-area';
import TagBox from 'devextreme-react/tag-box';
import { Button } from 'devextreme-react/button';
import { Validator, StringLengthRule } from 'devextreme-react/validator';

export interface Props {
    batchId: string;
    productId: string;
    analyticalScopeTypes: LookupItem[];
    onClose?: () => void;
}

// TODO: this needs to be reworked - 

export default function AddBatchBenchSheet(props: Props) {
    const [batchBenchSheetProductData, setBatchBenchSheetProductData] =
        useState<BatchBenchSheetProductData>();

    const [technologies, setTechnologies] =
        useState<Technology[]>();

    const [selectedTechnology, setSelectedTechnology] =
        useState<Technology>();

    const [technologyBasisTypes, setTechnologyBasisTypes] =
        useState<LookupItem[]>();

    const [analysisScopesSelectedItemKeys, setAnalysisScopesSelectedItemKeys] =
        useState<number[]>();

    //the right data type?
    const [compStandards, setCompStandards] =
        useState<CompStandard[]>();

    const [basisTypes, setBasisTypes] =
        useState<number[]>();

    const [notes, setNotes] =
        useState<string>();

    const [toastProps, setToastProps] =
        useState<ToastProps>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>()

    useEffect(() => {
        getAllData();
    }, [props.productId]);

    return (
        <div>
            <div className="pw-comp-row">
                <Button type="success" text="Search Analytical Plan Technology" icon="search" className="pw-button"
                />
            </div>
            <div>
                <div className="pw-form-unit">
                    <div className="pw-form-unit-label">Technology</div>
                    <SelectBox className="selectbox"
                        placeholder='technology'
                        displayExpr='name'
                        showClearButton={true}
                        dataSource={technologies ? technologies : []}
                        onValueChanged={onTechnologyChanged}
                        value={selectedTechnology ? selectedTechnology : null} />
                </div>
            </div>

            <div>
                <div className="pw-form-unit">
                    <div className="pw-form-unit-label">Basis Type</div>
                    <TagBox className="selectbox"
                        placeholder='basis types'
                        displayExpr="name"
                        valueExpr="id"
                        items={technologyBasisTypes ?
                            technologyBasisTypes : []}
                        showSelectionControls={true}
                        onValueChanged={onBasisTypeSelectionChanged}
                        value={basisTypes ?
                            basisTypes : []}
                        applyValueMode="useButtons" />
                </div>
            </div>

            <div className="pw-form-unit pw-comp-20 pw-margin-top-05">
                <div className="pw-form-unit-label">Applicable Characterizations</div>
                <List items={props.analyticalScopeTypes ?
                    props.analyticalScopeTypes : []} keyExpr="id"
                    className="dx-listbox"
                    height="12rem" selectionMode="multiple"
                    showSelectionControls={true}
                    itemRender={analysisScopesRender}
                    onOptionChanged={analysisScopeTypesChanged}
                    selectedItemKeys={analysisScopesSelectedItemKeys ?
                        analysisScopesSelectedItemKeys : []} />
            </div>

            {/*
            <div className="pw-form-unit pw-margin-top-05">
                <div className="pw-form-unit-label">Standards</div>
                <List height={'9rem'}
                    items={technology && technology.compStandards ?
                        technology.compStandards : []}
                    keyExpr="compStandardId"
                    itemRender={DataTemplates.CompStandardTemplate}
                    showSelectionControls={true}
                    selectionMode="multiple"
                    onOptionChanged={selectedNewBatchStandardsChanged}
                    selectedItems={compStandards ?
                        compStandards : []} />
               </div>
            */}

            <div className="pw-form-unit">
                <label className="textbox-label">Notes</label>
                <TextArea id="txtAddBenchSheetNotes"
                    className="textbox"
                    height='10rem'
                    onValueChanged={onAddBenchSheetNotesChanged}
                    placeholder="notes" value={notes}>
                    <Validator>
                        <StringLengthRule message="Long Name must be less than 100 characters in length." max={100} trim={true} />
                    </Validator>
                </TextArea>
            </div>

            <div className="pw-comp-row">
                <div className="pw-centered-buttons-container">
                    <Button type="success" className="pw-button" onClick={onAddBenchSheetClick} text="Save" />
                    <Button className="pw-button" onClick={closeDialog} text="Close" />
                </div>
            </div>

            {toastProps && toastProps.visible &&
                <Toast
                    visible={toastProps.visible}
                    message={toastProps.message}
                    type={toastProps.toastType}
                    onHiding={onToastHiding}
                    displayTime={600} />
            }

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }

        </div>
    );

    async function analysisScopeTypesChanged(e: any) {
        if (e.name === 'selectedItemKeys') {
            setAnalysisScopesSelectedItemKeys(e.value);

            // setAnalyticalPlan({ ...analyticalPlan, analysisScopeTypesList: e.value });
        }
    }

    async function onAddBenchSheetClick() {
        if (selectedTechnology) {
            let newAnalysisTypes: LookupItem[] = [];
            let newBasisTypes: LookupItem[] = [];

            basisTypes.forEach(b => {
                const matchingBasisType = technologyBasisTypes.find(tb => tb.id === b);

                if (matchingBasisType)
                    newBasisTypes.push(matchingBasisType);
            });

            const newBenchSheet: BenchSheet = {
                batchId: props.batchId,
                productId: props.productId,
                benchSheetTechnology: selectedTechnology.technologyId,
                basisTypes: newBasisTypes,
                scopeTypes: analysisScopesSelectedItemKeys,
                notes: notes
            };

            await insertBenchSheet(newBenchSheet)
                .then(() => {
                    showToast("Bench Sheet Created", "success");
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Inserting New Bench Sheet");
                });
        }
    }

    function closeDialog() {
        if (props.onClose)
            props.onClose();
    }

    function onAddBenchSheetNotesChanged(e: any) {
        setNotes(e.value);
    }

    function onBasisTypeSelectionChanged(e: any) {
        setBasisTypes(e.value);
    }

    function selectedNewBatchStandardsChanged(e: any) {
        if (e.name === 'selectedItems') {
            setCompStandards(e.value);
        }
    }

    function onTechnologyChanged(e: any) {
        setSelectedTechnology(e.value);

        if (batchBenchSheetProductData &&
            batchBenchSheetProductData.analyticalPlans) {

            let technologyId = e.value.technologyId as BenchSheetTechnologyType;

            setSelectedTechnology(e.value);
            setBasisTypes(null);

            if (technologyId && batchBenchSheetProductData.technologyBasisTypes) {

                const basisTypes = batchBenchSheetProductData.technologyBasisTypes.find(t => t.id === technologyId);

                setTechnologyBasisTypes(basisTypes && basisTypes.lookupItems ? basisTypes.lookupItems : []);

                const matchingAnalyticalPlan = batchBenchSheetProductData.analyticalPlans.find(ap =>
                    ap.analyticalTechnologyId === technologyId
                );

                if (matchingAnalyticalPlan && matchingAnalyticalPlan.basisTypes) {
                    const basisTypes = matchingAnalyticalPlan.basisTypes.map(at => at.id);
                    setBasisTypes(basisTypes);
                }
            }
        }
    }

    async function insertBenchSheet(benchSheet: BenchSheet) {
        return await CrudFunctions.postData("benchsheets/benchsheet", benchSheet)
    }

    async function getBatchBenchSheetProductData() {
        await CrudFunctions.getData(`products/batchbenchsheetproductdata/${props.productId}`)
            .then(data => {
                setBatchBenchSheetProductData(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Bench Sheet Product Data");
            });            
    }

    async function getTechnologies() {
        await CrudFunctions.getData("common/benchsheettechnologytypes")
            .then(data => {
                setTechnologies(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Technology List");
            });
    }

    async function getAllData() {
        await Promise.all([
            getTechnologies(),
            getBatchBenchSheetProductData()
        ]);
    }

    function analysisScopesRender(scope: LookupItem) {
        return (
            <div>
                <div>{scope.name}</div>
            </div>
        );
    }

    function showToast(message: string, toastType: string) {
        let toastParams: ToastProps = {
            message: message,
            toastType: toastType,
            visible: true
        };

        setToastProps(toastParams);
    }

    function onToastHiding() {
        let toastParams: ToastProps = {
            message: undefined,
            toastType: undefined,
            visible: false
        };

        setToastProps(toastParams);
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }
}